import React, { useState } from "react";
import { changePassword } from "../services/authService";

const emptyForm = {
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
};

export default function ChangePassword() {
  const [form, setForm] = useState(emptyForm);
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const changeField = ({ target: { name, value } }) => {
    setForm((current) => ({ ...current, [name]: value }));
    setErrors((current) => ({ ...current, [name]: "", form: "" }));
  };

  const submit = async (event) => {
    event.preventDefault();
    const nextErrors = {};

    if (!form.currentPassword) {
      nextErrors.currentPassword = "Enter your current password.";
    }
    if (!form.newPassword) {
      nextErrors.newPassword = "Enter a new password.";
    } else if (form.newPassword.length < 8) {
      nextErrors.newPassword = "New password must contain at least 8 characters.";
    } else if (form.newPassword === form.currentPassword) {
      nextErrors.newPassword = "Your new password must be different from your current password.";
    }
    if (!form.confirmPassword) {
      nextErrors.confirmPassword = "Confirm your new password.";
    } else if (form.confirmPassword !== form.newPassword) {
      nextErrors.confirmPassword = "Passwords do not match.";
    }

    if (Object.keys(nextErrors).length) {
      setErrors(nextErrors);
      return;
    }

    try {
      setSaving(true);
      setErrors({});
      await changePassword(form);
      setForm(emptyForm);
    } catch (requestError) {
      setErrors({
        form: requestError.message || "Unable to change your password. Please try again.",
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="main-wrapper">
      <div className="page-wrapper">
        <main className="page-content">
          <div className="card rounded-4">
            <div className="card-body p-4 p-md-5" style={{ maxWidth: 640 }}>
              {errors.form && <div className="alert alert-danger" role="alert">{errors.form}</div>}
              <form onSubmit={submit} noValidate>
                <div className="mb-3">
                  <label className="form-label" htmlFor="current-password">Current password</label>
                  <input
                    id="current-password"
                    name="currentPassword"
                    type="password"
                    autoComplete="current-password"
                    className={`form-control ${errors.currentPassword ? "is-invalid" : ""}`}
                    value={form.currentPassword}
                    onChange={changeField}
                    disabled={saving}
                  />
                  {errors.currentPassword && <div className="invalid-feedback">{errors.currentPassword}</div>}
                </div>
                <div className="mb-3">
                  <label className="form-label" htmlFor="new-password">New password</label>
                  <input
                    id="new-password"
                    name="newPassword"
                    type="password"
                    autoComplete="new-password"
                    className={`form-control ${errors.newPassword ? "is-invalid" : ""}`}
                    value={form.newPassword}
                    onChange={changeField}
                    disabled={saving}
                  />
                  {errors.newPassword ? (
                    <div className="invalid-feedback">{errors.newPassword}</div>
                  ) : (
                    <div className="form-text">Use at least 8 characters.</div>
                  )}
                </div>
                <div className="mb-4">
                  <label className="form-label" htmlFor="confirm-password">Confirm new password</label>
                  <input
                    id="confirm-password"
                    name="confirmPassword"
                    type="password"
                    autoComplete="new-password"
                    className={`form-control ${errors.confirmPassword ? "is-invalid" : ""}`}
                    value={form.confirmPassword}
                    onChange={changeField}
                    disabled={saving}
                  />
                  {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
                </div>
                <button type="submit" className="btn btn-primary" disabled={saving}>
                  {saving ? "Changing password…" : "Change password"}
                </button>
              </form>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
